import React from "react";
import DfoModule from "./views/sitehistory/DfoModele";
import CfoList from "./views/sitehistory/CfoList";
import CgmfList from "./views/sitehistory/CgmfList";
import BidderList from "./views/sitehistory/BidderList";
import BidderListView from "./views/sitehistory/BidderListView";
import Lotlist from "./views/sitehistory/LotList";
import LotDetails from "./views/sitehistory/LotDetails";
import LotBidderDetails from "./views/sitehistory/LotBidderDetails";
import LotGoodStatus from "./views/sitehistory/LotGoodStatus";
import AggrementPage from "./views/sitehistory/AggrementPage";
import LotExcel from "./views/sitehistory/LotExcel";
import LotActualQuantityImport from "./views/sitehistory/LotActualQuantityImport";
import BidderPayment from "./views/payment/BidderPayment";
import PaymentDetail from "./views/payment/PaymentDetail";
import TransferLot from "./views/sitehistory/TransferLot";
import OfflinePaymentWithType from "./views/payment/OfflinePaymentWithType";
import OfflinePaymentWithCheque from "./views/payment/OfflinePaymentWithTypeCheque";
import OfflinePayment from "./views/payment/OfflinePayment";
import BankGuaranteePayment from "./views/payment/BankGuaranteePayment";
import Ibeslist from "./views/sitehistory/Ibeslist";
import Agreementform from "./views/sitehistory/Agreementform";
import PaymentBidderDetails from "./views/payment/PaymentBidderDetails";
import Selectyourpayment from "./views/payment/Selectyourpayment";
import SelectyourpaymentForTransferlotEMD from "./views/payment/SelectyourpaymentForTransferlotEMD";
import BidderUploadedDetails from "./views/sitehistory/bidderDetailsUploaded";
import CircleList from "./views/sitehistory/CircleList";
//import AddUser from "./views/sitehistory/User/Admin/AddUser";
//import UserList from "./views/sitemaster/UserList";
//import UserList from "./view/sitehistory/user/"

import AddCircleList from "./views/sitehistory/AddCircle";
import EditCircle from "./views/sitehistory/EditCircle";
import DistrictList from "./views/sitehistory/District";
import EditDistrict from "./views/sitehistory/EditDistrict";
import AddDistrict from "./views/sitehistory/AddDistrict";
//import EditUser from "./views/sitehistory/User/Admin/EditUser";
import TenderList from "./views/sitehistory/TenderList";
import ReportTenderCircle from "./views/sitehistory/ReportTenderCircle";
import AddTender from "./views/sitehistory/AddTender";
import EditTender from "./views/sitehistory/EditTender";
import EditBidderDetails from "./views/sitehistory/EditBidderDetails";
import ViewSanctionLatter from "./views/sitehistory/Tender/View/ViewSanctionLatter";
import BankGuaranteePaymentList from "./views/sitehistory/BankGuaranteePaymentList";
import EMDBGPaymentList from "./views/sitehistory/EMDBGPaymentList";
import UpdatePaymentSuccessDate from "./views/sitehistory/UpdatePaymentSuccessDate";
import SenctionLetter from "./views/sitehistory/SenctionLetter";
//import BidderHome from "./views/sitehistory/BidderHome";
//import SiteHistory from "./views/sitehistory/site-history";
//import AdminDash from "./views/sitehistory/AdminDash";
//import OfficerDash from "./views/sitehistory/OfficerDash";
import Page404 from "./views/pages/page404/Page404";
import LotlistView from "./views/sitehistory/LotlistView";
import AddUserForTransfer from "./views/sitehistory/AddUserForTransfer";
import PendingApprovalList from "./views/sitehistory/PendingApprovalList";
import TransferLotList from "./views/sitehistory/TransferLotList";
import TransferLotDetails from "./views/sitehistory/TransferLotDetails";
import PendingApprovalView from "./views/sitehistory/PendingApprovalView";
import TransferLotRequestList from "./views/sitehistory/TransferLotRequestList";
import TransferToHoLotRequestList from "./views/sitehistory/TransferToHoLotRequestList";
import TransferLotRequestListView from "./views/sitehistory/TransferLotRequestListView";
import TransferLotRequestHOListView from "./views/sitehistory/TransferLotRequestHOListView";
import OfflinePaymentReqList from "./views/sitehistory/OfflinePaymentReqList";
import OfflinePaymentListView from "./views/sitehistory/OfflinePaymentListView";
import AdhocPayment from "./views/payment/AdhocPayment";
//import AdhocPaymentList from "./views/sitehistory/AdhocPaymentList";
import SubmitPayment from "./views/payment/SubmitPayment";
import SubmitLotTransferEMDPayment from "./views/payment/SubmitLotTransferEMDPayment";
import SubmitGodownRentPayment from "./views/payment/SubmitGodownRentPayment";
import GetResponse from "./views/payment/GetResponse";
import LotCompleteDetails from "./views/sitehistory/LotCompleteDetails";
import MISReport from "./views/sitehistory/MISReport";
import OnlinePaymentReport from "./views/sitehistory/OnlinePaymentReport";
import BGPaymentReport from "./views/sitehistory/BGPaymentReport";
import ChequePaymentReport from "./views/sitehistory/ChequePaymentReport";
import IncomeTaxRequestList from "./views/sitehistory/IncomeTaxRequestList";
import PaymentRefundReport from "./views/sitehistory/PaymentRefundReport";
import Test from "./views/sitehistory/Test";
import PaymentReceipt from "./views/payment/PaymentReceipt";
import Pgtest from "./views/sitehistory/Pgtest";
import SubmitAgreementExtend from "./views/payment/SubmitAgreementExtend";
import PendingAgreementextendListCFO from "./views/sitehistory/PendingAgreementextendListCFO";
import PendingAgreementextendListHO from "./views/sitehistory/PendingAgreementextendListHO";
import ABSBankGuaranteePaymentList from "./views/sitehistory/ABSBankGuaranteePaymentList";
import DownloadParidhanAadesh from "./views/sitehistory/DownloadParidhanAadesh";
import PBSMSLotWiseReport from "./views/sitehistory/Reports/PBSMS/LotWiseReport";
import PBSMSCricleWiseReport from "./views/sitehistory/Reports/PBSMS/CricleWiseReport";
import PBSMSDistrictWiseReport from "./views/sitehistory/Reports/PBSMS/DistrictWiseReport";
import PBSMSPaymentReceivedLotWiseReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedLotWiseReport";
import PBSMSPaymentReceivedLotWiseDetailReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedLotWiseDetailReport";
import PBSMSPaymentReceivedCircleWiseDetailReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedCircleWiseDetailReport";
import PBSMSPaymentReceivedDistrictWiseDetailReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedDistrictWiseDetailReport";
import PBSMSPaymentReceivedCircleWiseReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedCircleWiseReport";
import PBSMSPaymentReceivedDistrictWiseReport from "./views/sitehistory/Reports/PBSMS/PaymentReceivedDistrictWiseReport";
import PBSMSTransferedLotListReport from "./views/sitehistory/Reports/PBSMS/TransferedLotListReport";
import PBSMSAgreementExtensionReport from "./views/sitehistory/Reports/PBSMS/AgreementExtensionReport";
import PBSMSIncomeTaxConsessionRequestReport from "./views/sitehistory/Reports/PBSMS/IncomeTaxConsessionRequestReport";
import PBSMSBankGauranteeReceivedReport from "./views/sitehistory/Reports/PBSMS/BankGauranteeReceivedReport";
import PBSMSAgreementStatusReport from "./views/sitehistory/Reports/PBSMS/AgreementStatusReport";
import { BidderProfile } from "./views/sitehistory/BidderProfile";
import RoleList from "./views/sitehistory/RoleRights/RoleList";
import RoleEdit from "./views/sitehistory/RoleRights/RoleEdit";
import AddRole from "./views/sitehistory/RoleRights/RoleAdd";

//import Dashboard from "./views/dashboard/Dashboard";
import GoDownFeesExtensionList from "./views/sitehistory/GoDownFeesExtension/GoDownFeesExtensionList";
import GoDownFeesExtensionAdd from "./views/sitehistory/GoDownFeesExtension/GoDownFeesExtensionAdd";
import GoDownFeesExtensionEdit from "./views/sitehistory/GoDownFeesExtension/GoDownFeesExtensionEdit";
import SubmitGodownRentFeeExtensionPayment from "./views/payment/SubmitGodownRentFeeExtensionPayment";
import LotLeftRequestHoList from "./views/sitehistory/Lot/Left/LotLeftRequestHoList";
import SubmitLotLeftRequestPayment from "./views/payment/SubmitLotleftRequestPayment";
import LotLeftRequestReport from "./views/sitehistory/Reports/LotLeftRequestReport";
import CCFDashboard from "./views/sitehistory/Notification/CCFNotification";
import HONotification from "./views/sitehistory/Notification/HONotification";
import DFONotification from "./views/sitehistory/Notification/DFONotification";
import BidderDashboard from "./views/sitehistory/Dashboard/BidderDashboard";
import AdminUserList from "./views/sitehistory/User/Admin/AdminUserList";
import EditUser from "./views/sitehistory/User/Admin/EditUser";
import AddUser from "./views/sitehistory/User/Admin/AddUser";
import RevertIncomeTaxConcession from "./views/sitehistory/BackendActivity/RevertEntry/IncomeTaxConcession/RevertIncomeTaxConcession";
import RevertABS from "./views/sitehistory/BackendActivity/RevertEntry/ABS/RevertABS";
import RevertAdjustAmtFormDFO from "./views/sitehistory/BackendActivity/RevertEntry/AdjustAmtFormDFO/RevertAdjustAmtFormDFO";
import ChequeClearingList from "./views/sitehistory/Cheque/ChequeClearing/ChequeClearingList";
import AdHocPaymentList from "./views/sitehistory/AdHocPayment/AdHocPaymentList";
import AdHocPaymentAdd from "./views/sitehistory/AdHocPayment/AdHocPaymentAdd";
import AdHocPaymentView from "./views/sitehistory/AdHocPayment/AdHocPaymentView";
import SubmitAdHocPayment from "./views/payment/SubmitAdHocPayment";
import AdHocPaymentEdit from "./views/sitehistory/AdHocPayment/AdHocPaymentEdit";
import LotInvoiceList from "./views/sitehistory/Lot/Invoice/LotInvoiceList";

const CrudCreate = React.lazy(() => import("./views/crud/create"));
const SiteAdd = React.lazy(() => import("./views/sitemaster/add-site"));
const SiteList = React.lazy(() => import("./views/sitemaster/site-list"));

export const dfoRoutes = [
  // {
  //   path: "/dashbordDefault",
  //   exact: true,
  //   name: "dashbordDefault",
  //   component: Dashboard,
  // },
  { path: "/crud/create", exact: true, name: "Create", component: CrudCreate },
  { path: "/datalist", exact: true, name: "List", component: SiteList },
  {
    path: "/datalist/create",
    exact: true,
    name: "Create",
    component: SiteAdd,
  },
  {
    path: "/ABSbankguaranteelist",
    exact: true,
    name: "Home",
    component: ABSBankGuaranteePaymentList,
  },
  {
    path: "/DownloadParidhanAadesh",
    exact: true,
    name: "Home",
    component: DownloadParidhanAadesh,
  },
  {
    path: "/onlinepaymentreport",
    exact: true,
    name: "Home",
    component: OnlinePaymentReport,
  },
  // {
  //   path: "/bgpaymentreport",
  //   exact: true,
  //   name: "Home",
  //   component: BGPaymentReport,
  // },
  {
    path: "/bgpaymentreport",
    exact: true,
    name: "Home",
    component: PBSMSBankGauranteeReceivedReport,
  },
  {
    path: "/chequepaymentreport",
    exact: true,
    name: "Home",
    component: ChequePaymentReport,
  },

  {
    path: "/receipt/:id",
    exact: true,
    name: "Home",
    component: PaymentReceipt,
  },
  {
    path: "/",
    exact: true,
    name: "Home",
    component: DFONotification,
  },
  // {
  //   path: "/",
  //   exact: true,
  //   name: "Home",
  //   component: AdminDash,
  // },
  {
    path: "/bidderlist",
    exact: true,
    name: "Home",
    component: BidderList,
  },
  // {
  //   path: "/transferlotapprovals",
  //   exact: true,
  //   name: "Home",
  //   component: TransferLotRequestList,
  // },
  {
    // not use in navbar
    path: "/transfertoholotapprovals",
    exact: true,
    name: "Home",
    component: TransferToHoLotRequestList,
  },
  {
    path: "/transferlotapprovalview/:lotTransferId",
    exact: true,
    name: "Home",
    component: TransferLotRequestListView,
  },
  {
    path: "/bidderlistview/:userId",
    exact: true,
    name: "Home",
    component: BidderListView,
  },
  {
    path: "/transferlotlist",
    exact: true,
    name: "Home",
    component: TransferLotList,
  },
  {
    path: "/lotlistview/:lotId",
    exact: true,
    name: "Home",
    component: LotlistView,
  },
  {
    path: "/lotlist",
    exact: true,
    name: "Home",
    component: Lotlist,
  },

  {
    path: "/lotbidderdetails",
    exact: true,
    name: "Home",
    component: LotBidderDetails,
  },
  {
    path: "/lotgoodstatus",
    exact: true,
    name: "Home",
    component: LotGoodStatus,
  },
  {
    path: "/aggrementpage",
    exact: true,
    name: "Home",
    component: AggrementPage,
  },

  {
    path: "/bidderpayment",
    exact: true,
    name: "Home",
    component: BidderPayment,
  },

  {
    path: "/offlinepayment",
    exact: true,
    name: "Home",
    component: OfflinePayment,
  },
  {
    path: "/OfflinePaymentWithType/:lotid/:type",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithType,
  },
  {
    path: "/OfflinePaymentWithTypeCheque/:lotid",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithCheque,
  },
  {
    path: "/bankguaranteepayment",
    exact: true,
    name: "Home",
    component: BankGuaranteePayment,
  },

  {
    path: "/agreementform",
    exact: true,
    name: "Home",
    component: Agreementform,
  },
  {
    path: "/paymentbidderdetails",
    exact: true,
    name: "Home",
    component: PaymentBidderDetails,
  },
  {
    path: "/selectpaymentmethod",
    exact: true,
    name: "Home",
    component: Selectyourpayment,
  },
  {
    path: "/bidderuploadeddetails",
    exact: true,
    name: "Home",
    component: BidderUploadedDetails,
  },
  {
    path: "/circlelist",
    exact: true,
    name: "Home",
    component: CircleList,
  },
  {
    path: "/adduser",
    exact: true,
    name: "Home",
    component: AddUser,
  },
  {
    path: "/userlist",
    exact: true,
    name: "Home",
    component: AdminUserList,
  },
  {
    path: "/test",
    exact: true,
    name: "Home",
    component: Test,
  },
  {
    path: "/addcircle",
    exact: true,
    name: "Home",
    component: AddCircleList,
  },
  {
    path: "/editcircle/:id",
    exact: true,
    name: "Home",
    component: EditCircle,
  },
  {
    path: "/districtlilst",
    exact: true,
    name: "Home",
    component: DistrictList,
  },
  {
    path: "/editdistrict/:id",
    exact: true,
    name: "Home",
    component: EditDistrict,
  },
  {
    path: "/adddistrict",
    exact: true,
    name: "Home",
    component: AddDistrict,
  },
  {
    path: "/edituser/:id",
    exact: true,
    name: "Home",
    component: EditUser,
  },
  {
    path: "/tenderlist",
    exact: true,
    name: "Home",
    component: TenderList,
  },
  {
    path: "/tendercirclereport/:id",
    exact: true,
    name: "Home",
    component: ReportTenderCircle,
  },
  {
    path: "/bankguaranteelist",
    exact: true,
    name: "Home",
    component: BankGuaranteePaymentList,
  },
  {
    path: "/addtender",
    exact: true,
    name: "Home",
    component: AddTender,
  },
  {
    path: "/edittender/:id/:mode",
    exact: true,
    name: "Home",
    component: EditTender,
  },
  {
    path: "/editbidderdetails/:userId",
    exact: true,
    name: "Home",
    component: EditBidderDetails,
  },
  {
    path: "/ViewSanctionLatter/:id",
    exact: true,
    name: "Home",
    component: ViewSanctionLatter,
  },
  {
    path: "/senctionLetter/:id",
    exact: true,
    name: "Home",
    component: SenctionLetter,
  },
  {
    path: "/GoDownFeesExtension/List",
    exact: true,
    name: "Home",
    component: GoDownFeesExtensionList,
  },
  {
    path: "/GoDownFeesExtension/Add",
    exact: true,
    name: "Home",
    component: GoDownFeesExtensionAdd,
  },
  {
    path: "/GoDownFeesExtension/Edit/:id",
    exact: true,
    name: "Home",
    component: GoDownFeesExtensionEdit,
  },
  {
    path: "/ChequeClearing/List",
    exact: true,
    name: "Home",
    component: ChequeClearingList,
  },
  {
    path: "/lot/adhocpayment",
    exact: true,
    name: "Home",
    component: AdHocPaymentList,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/type/:type",
    exact: true,
    name: "Home",
    component: AdHocPaymentList,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/Add",
    exact: true,
    name: "Home",
    component: AdHocPaymentAdd,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/view/:AdHocPaymentId",
    exact: true,
    name: "Home",
    component: AdHocPaymentView,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/edit/:AdHocPaymentId",
    exact: true,
    name: "Home",
    component: AdHocPaymentEdit,
  },
  {
    accessKey: "lot_invoice_list",
    path: "/invoice",
    exact: true,
    name: "Home",
    component: LotInvoiceList,
  },

  {
    path: "*",
    exact: false,
    name: "Home",
    component: Page404,
  },
];

export const cfoRoutes = [
  { path: "/crud/create", exact: true, name: "Create", component: CrudCreate },
  { path: "/datalist", exact: true, name: "List", component: SiteList },
  {
    path: "/datalist/create",
    exact: true,
    name: "Create",
    component: SiteAdd,
  },
  {
    path: "/receipt/:id",
    exact: true,
    name: "Home",
    component: PaymentReceipt,
  },
  {
    path: "/",
    exact: true,
    name: "Home",
    component: CCFDashboard,
  },

  {
    path: "/bidderlist",
    exact: true,
    name: "Home",
    component: BidderList,
  },
  {
    path: "/transferlotlist",
    exact: true,
    name: "Home",
    component: TransferLotList,
  },
  {
    path: "/bidderlistview/:userId",
    exact: true,
    name: "Home",
    component: BidderListView,
  },
  {
    path: "/lotlistview/:lotId",
    exact: true,
    name: "Home",
    component: LotlistView,
  },
  {
    path: "/lotlist",
    exact: true,
    name: "Home",
    component: Lotlist,
  },
  {
    path: "/lotlist/:type",
    exact: true,
    name: "Home",
    component: Lotlist,
  },

  {
    path: "/PendingAgreementextendListCFO",
    exact: true,
    name: "Home",
    component: PendingAgreementextendListCFO,
  },

  {
    path: "/lotbidderdetails",
    exact: true,
    name: "Home",
    component: LotBidderDetails,
  },
  {
    path: "/lotgoodstatus",
    exact: true,
    name: "Home",
    component: LotGoodStatus,
  },
  {
    path: "/aggrementpage",
    exact: true,
    name: "Home",
    component: AggrementPage,
  },

  {
    path: "/bidderpayment",
    exact: true,
    name: "Home",
    component: BidderPayment,
  },
  {
    path: "/offlinepayment",
    exact: true,
    name: "Home",
    component: OfflinePayment,
  },
  {
    path: "/onlinepaymentreport",
    exact: true,
    name: "Home",
    component: OnlinePaymentReport,
  },
  // {
  //   path: "/bgpaymentreport",
  //   exact: true,
  //   name: "Home",
  //   component: BGPaymentReport,
  // },
  {
    path: "/bgpaymentreport",
    exact: true,
    name: "Home",
    component: PBSMSBankGauranteeReceivedReport,
  },
  {
    path: "/chequepaymentreport",
    exact: true,
    name: "Home",
    component: ChequePaymentReport,
  },
  {
    path: "/OfflinePaymentWithType/:lotid/:type",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithType,
  },
  {
    path: "/OfflinePaymentWithTypeCheque/:lotid",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithCheque,
  },
  {
    path: "/bankguaranteepayment",
    exact: true,
    name: "Home",
    component: BankGuaranteePayment,
  },

  {
    path: "/agreementform",
    exact: true,
    name: "Home",
    component: Agreementform,
  },
  {
    path: "/paymentbidderdetails",
    exact: true,
    name: "Home",
    component: PaymentBidderDetails,
  },
  {
    path: "/selectpaymentmethod",
    exact: true,
    name: "Home",
    component: Selectyourpayment,
  },
  {
    path: "/bidderuploadeddetails",
    exact: true,
    name: "Home",
    component: BidderUploadedDetails,
  },
  {
    path: "/circlelist",
    exact: true,
    name: "Home",
    component: CircleList,
  },
  {
    path: "/adduser",
    exact: true,
    name: "Home",
    component: AddUser,
  },
  {
    path: "/userlist",
    exact: true,
    name: "Home",
    component: AdminUserList,
  },
  {
    path: "/test",
    exact: true,
    name: "Home",
    component: Test,
  },
  {
    path: "/addcircle",
    exact: true,
    name: "Home",
    component: AddCircleList,
  },
  {
    path: "/editcircle/:id",
    exact: true,
    name: "Home",
    component: EditCircle,
  },
  {
    path: "/districtlilst",
    exact: true,
    name: "Home",
    component: DistrictList,
  },
  {
    path: "/editdistrict/:id",
    exact: true,
    name: "Home",
    component: EditDistrict,
  },
  {
    path: "/transferlotapprovals",
    exact: true,
    name: "Home",
    component: TransferLotRequestList,
  },
  {
    path: "/transferlotapprovals/:type",
    exact: true,
    name: "Home",
    component: TransferLotRequestList,
  },
  {
    path: "/transferlotapprovalview/:lotTransferId",
    exact: true,
    name: "Home",
    component: TransferLotRequestListView,
  },
  {
    path: "/adddistrict",
    exact: true,
    name: "Home",
    component: AddDistrict,
  },
  {
    path: "/edituser/:id",
    exact: true,
    name: "Home",
    component: EditUser,
  },
  {
    path: "/tenderlist",
    exact: true,
    name: "Home",
    component: TenderList,
  },
  {
    path: "/tendercirclereport/:id",
    exact: true,
    name: "Home",
    component: ReportTenderCircle,
  },
  {
    path: "/bankguaranteelist",
    exact: true,
    name: "Home",
    component: BankGuaranteePaymentList,
  },
  {
    path: "/emdbgpaymentList",
    exact: true,
    name: "Home",
    component: EMDBGPaymentList,
  },

  {
    path: "/addtender",
    exact: true,
    name: "Home",
    component: AddTender,
  },
  {
    path: "/edittender/:id/:mode",
    exact: true,
    name: "Home",
    component: EditTender,
  },
  {
    path: "/editbidderdetails/:userId",
    exact: true,
    name: "Home",
    component: EditBidderDetails,
  },
  {
    path: "/ViewSanctionLatter/:id",
    exact: true,
    name: "Home",
    component: ViewSanctionLatter,
  },
  {
    path: "/senctionLetter/:id",
    exact: true,
    name: "Home",
    component: SenctionLetter,
  },
  {
    path: "*",
    exact: false,
    name: "Home",
    component: Page404,
  },
];
const cgmfRoutes = [
  {
    accessKey: "cgmfdashboard",
    path: "/",
    exact: true,
    name: "Home",
    component: HONotification,
  },
  // {
  //   accessKey: "cgmfdashboard",
  //   path: "/cgmfdashboard",
  //   exact: true,
  //   name: "Home",
  //   component: SiteHistory,
  // },

  {
    //Multipe place route but not Required Condition check is role = CGMF
    accessKey: "master_circlelist",
    path: "/master/circlelist",
    exact: true,
    name: "Home",
    component: CircleList,
  },
  {
    accessKey: "master_circlelist",
    path: "/addcircle",
    exact: true,
    name: "Home",
    component: AddCircleList,
  },
  {
    accessKey: "master_circlelist",
    path: "/editcircle/:id",
    exact: true,
    name: "Home",
    component: EditCircle,
  },
  {
    //Multipe place route but not Required Condition check is role = CGMF
    accessKey: "master_districtlilst",
    path: "/master/districtlilst",
    exact: true,
    name: "Home",
    component: DistrictList,
  },
  {
    accessKey: "master_districtlilst",
    path: "/adddistrict",
    exact: true,
    name: "Home",
    component: AddDistrict,
  },
  {
    accessKey: "master_districtlilst",
    path: "/editdistrict/:id",
    exact: true,
    name: "Home",
    component: EditDistrict,
  },

  {
    //Multipe place route but Required Condition check is role = CGMF
    accessKey: "master_userlist",
    path: "/master/userlist",
    exact: true,
    name: "Home",
    component: AdminUserList,
  },
  {
    accessKey: "master_userlist",
    path: "/adduser",
    exact: true,
    name: "Home",
    component: AddUser,
  },
  {
    accessKey: "master_userlist",
    path: "/edituser/:id",
    exact: true,
    name: "Home",
    component: EditUser,
  },

  {
    accessKey: "master_role",
    path: "/master/role",
    exact: true,
    name: "Home",
    component: RoleList,
  },
  {
    accessKey: "master_role",
    path: "/master/role/add",
    exact: true,
    name: "Home",
    component: AddRole,
  },
  {
    accessKey: "master_role",
    path: "/master/role/:id/:mode",
    exact: true,
    name: "Home",
    component: RoleEdit,
  },
  {
    accessKey: "master_bidderlist",
    path: "/master/bidderlist",
    exact: true,
    name: "Home",
    component: BidderList,
  },
  {
    accessKey: "master_bidderlist",
    path: "/editbidderdetails/:userId",
    exact: true,
    name: "Home",
    component: EditBidderDetails,
  },
  {
    accessKey: "master_bidderlist",
    path: "/bidderlistview/:userId",
    exact: true,
    name: "Home",
    component: BidderListView,
  },
  //tender

  {
    accessKey: "tender_lotlist",
    path: "/tender/selectlotlist",
    exact: true,
    name: "Home",
    component: Lotlist,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/tender/tenderlist",
    exact: true,
    name: "Home",
    component: TenderList,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/addtender",
    exact: true,
    name: "Home",
    component: AddTender,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/edittender/:id/:mode",
    exact: true,
    name: "Home",
    component: EditTender,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/ViewSanctionLatter/:id",
    exact: true,
    name: "Home",
    component: ViewSanctionLatter,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/tendercirclereport/:id",
    exact: true,
    name: "Home",
    component: ReportTenderCircle,
  },
  {
    accessKey: "tender_tenderlist",
    path: "/senctionLetter/:id",
    exact: true,
    name: "Home",
    component: SenctionLetter,
  },
  {
    accessKey: "tender_importlotexcelsheet",
    path: "/tender/importlotexcelsheet",
    exact: true,
    name: "Home",
    component: LotExcel,
  },
  {
    accessKey: "tender_importbidderexcel",
    path: "/tender/importbidderexcel",
    exact: true,
    name: "Home",
    component: Ibeslist,
  },

  //lot
  {
    accessKey: "lot_lotdetails",
    path: "/lots/lotdetails",
    exact: true,
    name: "Home",
    component: LotDetails,
  },
  {
    accessKey: "lot_lotdetails",
    path: "/lotlistview/:lotId",
    exact: true,
    name: "Home",
    component: LotlistView,
  },
  {
    accessKey: "lot_lotdetails",
    path: "/OfflinePaymentWithTypeCheque/:lotid",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithCheque,
  },
  {
    // multiple place - lotlistView , transferLotDetails
    accessKey: "lot_lotdetails",
    path: "/selectpaymentmethod",
    exact: true,
    name: "Home",
    component: Selectyourpayment,
  },
  {
    //multiple place
    accessKey: "lot_lotdetails",
    path: "/receipt/:id",
    exact: true,
    name: "Home",
    component: PaymentReceipt,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/view/:AdHocPaymentId",
    exact: true,
    name: "Home",
    component: AdHocPaymentView,
  },
  // {
  //   accessKey: "lot_adhocpayment",
  //   path: "/lot/adhocpayment/Add",
  //   exact: true,
  //   name: "Home",
  //   component: AdHocPaymentAdd,
  // },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment",
    exact: true,
    name: "Home",
    component: AdHocPaymentList,
  },
  {
    accessKey: "lot_adhocpayment",
    path: "/lot/adhocpayment/type/:type",
    exact: true,
    name: "Home",
    component: AdHocPaymentList,
  },

  {
    accessKey: "lot_transferlotlist",
    path: "/lot/transferlotlist",
    exact: true,
    name: "Home",
    component: TransferLotList,
  },
  {
    accessKey: "lot_transferlotlist",
    path: "/transferlotdetails/:lotId",
    exact: true,
    name: "Home",
    component: TransferLotDetails,
  },
  {
    //multiple place
    accessKey: "lot_transferlotlist",
    path: "/receipt/:id",
    exact: true,
    name: "Home",
    component: PaymentReceipt,
  },
  {
    // multiple place - lotlistView , transferLotDetails
    accessKey: "lot_transferlotlist",
    path: "/selectpaymentmethod",
    exact: true,
    name: "Home",
    component: Selectyourpayment,
  },

  {
    accessKey: "lot_importactualquantity",
    path: "/lot/importactualquantity",
    exact: true,
    name: "Home",
    component: LotActualQuantityImport,
  },

  // Request List Menu
  {
    //Multiple Route
    accessKey: "requestlist_bankguaranteelist",
    path: "/requestlist/bankguaranteelist",
    exact: true,
    name: "Home",
    component: BankGuaranteePaymentList,
  },
  {
    accessKey: "requestlist_transfertoholotapprovals",
    path: "/requestlist/transfertoholotapprovals",
    exact: true,
    name: "Home",
    component: TransferToHoLotRequestList,
  },
  {
    accessKey: "requestlist_transfertoholotapprovals",
    path: "/transferlotapprovalviewho/:lotTransferId",
    exact: true,
    name: "Home",
    component: TransferLotRequestHOListView,
  },

  {
    accessKey: "requestlist_transfertoholotapprovals",
    path: "/transferlotapprovalview/:lotTransferId",
    exact: true,
    name: "Home",
    component: TransferLotRequestListView,
  },

  {
    accessKey: "requestlist_incometaxconsessionrequest",
    path: "/requestlist/incometaxconsessionrequest",
    exact: true,
    name: "Home",
    component: IncomeTaxRequestList,
  },
  {
    accessKey: "requestlist_PendingAgreementextendListHO",
    path: "/requestlist/PendingAgreementextendListHO",
    exact: true,
    name: "Home",
    component: PendingAgreementextendListHO,
  },
  {
    accessKey: "requestlist_pendingapprovals",
    path: "/requestlist/pendingapprovals",
    exact: true,
    name: "Home",
    component: PendingApprovalList,
  },
  {
    accessKey: "requestlist_pendingapprovals",
    path: "/pendingapprovalview/:userId",
    exact: true,
    name: "Home",
    component: PendingApprovalView,
  },

  {
    accessKey: "requestlist_lotleftrequestlistho",
    path: "/requestlist/leftlotrequestlistho",
    exact: true,
    name: "Home",
    component: LotLeftRequestHoList,
  },
  //Report
  {
    accessKey: "report_refundreport",
    path: "/report/refundreport",
    exact: true,
    name: "Home",
    component: PaymentRefundReport,
  },
  {
    //Multipe place route but not Required Condition check is role = CGMF
    accessKey: "report_onlinepaymentreport",
    path: "/report/onlinepaymentreport",
    exact: true,
    name: "Home",
    component: OnlinePaymentReport,
  },
  {
    //Multipe place route but not Required Condition check is role = CGMF
    accessKey: "report_bgpaymentreport",
    path: "/report/bgpaymentreport",
    exact: true,
    name: "Home",
    component: BGPaymentReport,
  },

  {
    //Multipe place route but not Required Condition check is role = CGMF
    accessKey: "report_chequepaymentreport",
    path: "/report/chequepaymentreport",
    exact: true,
    name: "Home",
    component: ChequePaymentReport,
  },

  // {
  //   accessKey: "report_emdbgpaymentList",
  //   path: "/report/emdbgpaymentList",
  //   exact: true,
  //   name: "Home",
  //   component: EMDBGPaymentList,
  // },
  {
    accessKey: "report_pbsms_rlot",
    path: "/report/pbsms/rlot",
    exact: true,
    name: "Home",
    component: PBSMSLotWiseReport,
  },
  {
    accessKey: "report_pbsms_cricle",
    path: "/report/pbsms/cricle",
    exact: true,
    name: "Home",
    component: PBSMSCricleWiseReport,
  },
  {
    accessKey: "report_pbsms_district",
    path: "/report/pbsms/district",
    exact: true,
    name: "Home",
    component: PBSMSDistrictWiseReport,
  },
  {
    accessKey: "report_pbsms_prlot",
    path: "/report/pbsms/prlot",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedLotWiseReport,
  },
    {
    accessKey: "report_pbsms_prlotdetail",
    path: "/report/pbsms/prlotdetailreport",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedLotWiseDetailReport,
  },
  {
    accessKey: "report_pbsms_prcricle",
    path: "/report/pbsms/prcricle",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedCircleWiseReport,
  },
    {
    accessKey: "report_pbsms_prcircledetail",
    path: "/report/pbsms/prcricledetailreport",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedCircleWiseDetailReport,
  },
      {
    accessKey: "report_InvoiceList",
    path: "/lot/LotInvoiceList",
    exact: true,
    name: "Home",
    component: LotInvoiceList,
  },
  {
    accessKey: "report_pbsms_prdistrict",
    path: "/report/pbsms/prdistrict",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedDistrictWiseReport,
  },
   {
    accessKey: "report_pbsms_prdistrictdetail",
    path: "/report/pbsms/prdistrictdetailreport",
    exact: true,
    name: "Home",
    component: PBSMSPaymentReceivedDistrictWiseDetailReport,
  },
  {
    accessKey: "report_pbsms_transferedlot",
    path: "/report/pbsms/transferedlot",
    exact: true,
    name: "Home",
    component: PBSMSTransferedLotListReport,
  },
  {
    accessKey: "report_pbsms_itconsessionrequest",
    path: "/report/pbsms/itconsessionrequest",
    exact: true,
    name: "Home",
    component: PBSMSIncomeTaxConsessionRequestReport,
  },
  {
    accessKey: "report_pbsms_agreementextension",
    path: "/report/pbsms/agreementextension",
    exact: true,
    name: "Home",
    component: PBSMSAgreementExtensionReport,
  },
  {
    accessKey: "report_pbsms_bgreceived",
    path: "/report/pbsms/bgreceived",
    exact: true,
    name: "Home",
    component: PBSMSBankGauranteeReceivedReport,
  },
  {
    accessKey: "report_pbsms_agreementstatus",
    path: "/report/pbsms/agreementstatus",
    exact: true,
    name: "Home",
    component: PBSMSAgreementStatusReport,
  },

  {
    accessKey: "report_lotleft",
    path: "/report/leftlot",
    exact: true,
    name: "Home",
    component: LotLeftRequestReport,
  },
  {
    accessKey: "report_cgmflist",
    path: "/report/cgmflist",
    exact: true,
    name: "Home",
    component: CgmfList,
  },
  {
    accessKey: "report_cfolist",
    path: "/report/cfolist",
    exact: true,
    name: "Home",
    component: CfoList,
  },

  {
    accessKey: "report_dfolist",
    path: "/report/dfolist",
    exact: true,
    name: "Home",
    component: DfoModule,
  },

  /// Conditional Added may be
  {
    // Multipe place
    path: "/OfflinePaymentWithType/:lotid/:type",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithType,
  },

  //other menu
  {
    accessKey: "other_offlinepaymentslist",
    path: "/other/offlinepaymentslist",
    exact: true,
    name: "Home",
    component: OfflinePaymentReqList,
  },
  {
    accessKey: "other_offlinepaymentslist",
    path: "/offlinepaymentslistview/:id",
    exact: true,
    name: "Home",
    component: OfflinePaymentListView,
  },
  {
    accessKey: "other_adhocpayment",
    path: "/other/adhocpayment",
    exact: true,
    name: "Home",
    component: AdhocPayment,
  },
  {
    accessKey: "other_completelotdetails",
    path: "/other/completelotdetails",
    exact: true,
    name: "Home",
    component: LotCompleteDetails,
  },
  {
    accessKey: "other_misreport",
    path: "/other/misreport",
    exact: true,
    name: "Home",
    component: MISReport,
  },

  {
    accessKey: "backendactivity_revert_abs",
    path: "/backendactivity/revert_ABS",
    exact: true,
    name: "Home",
    component: RevertABS,
  },
  {
    accessKey: "backendactivity_revert_incometaxconcession",
    path: "/backendactivity/revert_IncomeTaxConcession",
    exact: true,
    name: "Home",
    component: RevertIncomeTaxConcession,
  },
  {
    accessKey: "backendactivity_revert_adjustamtformdfo",
    path: "/backendactivity/revert_AdjustAmtFormDFO",
    exact: true,
    name: "Home",
    component: RevertAdjustAmtFormDFO,
  },

  //other link
  {
    // not use
    path: "/updatepaymentsuccessdate",
    exact: true,
    name: "Home",
    component: UpdatePaymentSuccessDate,
  },

  {
    path: "/crud/create",
    exact: true,
    name: "Create",
    component: CrudCreate,
  },
  { path: "/datalist", exact: true, name: "List", component: SiteList },
  {
    path: "/datalist/create",
    exact: true,
    name: "Create",
    component: SiteAdd,
  },

  // {
  //   path: "/transferlotapprovals",
  //   exact: true,
  //   name: "Home",
  //   component: TransferLotRequestList,
  // },

  {
    //not use
    path: "/pgtest",
    exact: true,
    name: "Home",
    component: Pgtest,
  },

  {
    // not use
    path: "/lotbidderdetails",
    exact: true,
    name: "Home",
    component: LotBidderDetails,
  },
  {
    //not use
    path: "/lotgoodstatus",
    exact: true,
    name: "Home",
    component: LotGoodStatus,
  },
  {
    //not use
    path: "/aggrementpage",
    exact: true,
    name: "Home",
    component: AggrementPage,
  },

  {
    //not use
    path: "/bidderpayment",
    exact: true,
    name: "Home",
    component: BidderPayment,
  },
  {
    //not use in CGMF use in CFO in nav.js
    path: "/paymentdetails",
    exact: true,
    name: "Home",
    component: PaymentDetail,
  },

  {
    //not use
    path: "/offlinepayment",
    exact: true,
    name: "Home",
    component: OfflinePayment,
  },

  {
    // not use
    path: "/bankguaranteepayment",
    exact: true,
    name: "Home",
    component: BankGuaranteePayment,
  },

  {
    // not use
    path: "/agreementform",
    exact: true,
    name: "Home",
    component: Agreementform,
  },
  {
    // not use
    path: "/paymentbidderdetails",
    exact: true,
    name: "Home",
    component: PaymentBidderDetails,
  },

  {
    // not use
    path: "/bidderuploadeddetails",
    exact: true,
    name: "Home",
    component: BidderUploadedDetails,
  },

  {
    path: "/test",
    exact: true,
    name: "Home",
    component: Test,
  },
];

export const bidderRoutes = [
  { path: "/crud/create", exact: true, name: "Create", component: CrudCreate },
  { path: "/datalist", exact: true, name: "List", component: SiteList },
  {
    path: "/datalist/create",
    exact: true,
    name: "Create",
    component: SiteAdd,
  },

  {
    path: "/",
    exact: true,
    name: "Home",
    component: BidderDashboard,
  },
  // {
  //   path: "/",
  //   exact: true,
  //   name: "Home",
  //   component: BidderHome,
  // },
  {
    path: "/transferlotlist",
    exact: true,
    name: "Home",
    component: TransferLotList,
  },
  // {
  //   path: "/bidderlist",
  //   exact: true,
  //   name: "Home",
  //   component: LoginPage,
  // },

  {
    path: "/lotlistview/:lotId",
    exact: true,
    name: "Home",
    component: LotlistView,
  },
  {
    path: "/submitpayment/:id/:amount/:lotpaymentid",
    exact: true,
    name: "Home",
    component: SubmitPayment,
  },
  {
    path: "/submitlottransferemdpayment/:id/:paymenttype",
    exact: true,
    name: "Home",
    component: SubmitLotTransferEMDPayment,
  },
  {
    path: "/submitgodownrentpayment/:id/:amount/:latefees/:ispaywithouttds",
    exact: true,
    name: "Home",
    component: SubmitGodownRentPayment,
  },
  {
    path: "/submitgodownrentfeeextensionpayment/:id/:grfeid/:amount/:latefees/:ispaywithouttds",
    exact: true,
    name: "Home",
    component: SubmitGodownRentFeeExtensionPayment,
  },
  {
    path: "/submitadhocpayment/:id/:ahpid/:amount/:latefees",
    exact: true,
    name: "Home",
    component: SubmitAdHocPayment,
  },
  {
    path: "/SubmitAgreementExtend/:id/:comment/:is7day/:amount",
    exact: true,
    name: "Home",
    component: SubmitAgreementExtend,
  },
  {
    path: "/submitlotleftrequestpayment/:id/:llrid/:amount",
    exact: true,
    name: "Home",
    component: SubmitLotLeftRequestPayment,
  },

  {
    path: "/lotlist",
    exact: true,
    name: "Home",
    component: Lotlist,
  },
  {
    path: "/receipt/:id",
    exact: true,
    name: "Home",
    component: PaymentReceipt,
  },
  // {
  //   path: "/adhocpaymentlist",
  //   exact: true,
  //   name: "Home",
  //   component: AdhocPaymentList,
  // },
  {
    path: "/getresponse/:id",
    exact: true,
    name: "Home",
    component: GetResponse,
  },
  // {
  //   path: "/lotbidderdetails",
  //   exact: true,
  //   name: "Home",
  //   component: LotBidderDetails,
  // },
  {
    path: "/lotgoodstatus",
    exact: true,
    name: "Home",
    component: LotGoodStatus,
  },
  {
    path: "/aggrementpage",
    exact: true,
    name: "Home",
    component: AggrementPage,
  },
  // {
  //   path: "/lotexcelsheet",
  //   exact: true,
  //   name: "Home",
  //   component: LotExcel,
  // },
  // {
  //   path: "/bidderpayment",
  //   exact: true,
  //   name: "Home",
  //   component: BidderPayment,
  // },
  {
    path: "/paymentdetails",
    exact: true,
    name: "Home",
    component: PaymentDetail,
  },
  {
    path: "/transferlot/:lotId",
    exact: true,
    name: "Home",
    component: TransferLot,
  },
  {
    path: "/offlinepayment/:lotTransferId",
    exact: true,
    name: "Home",
    component: OfflinePayment,
  },
  {
    path: "/OfflinePaymentWithType/:lotid/:type",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithType,
  },
  {
    path: "/OfflinePaymentWithTypeCheque/:lotid",
    exact: true,
    name: "Home",
    component: OfflinePaymentWithCheque,
  },
  {
    path: "/bankguaranteepayment",
    exact: true,
    name: "Home",
    component: BankGuaranteePayment,
  },

  {
    path: "/agreementform",
    exact: true,
    name: "Home",
    component: Agreementform,
  },
  {
    path: "/paymentbidderdetails",
    exact: true,
    name: "Home",
    component: PaymentBidderDetails,
  },
  {
    path: "/selectpaymentmethod/:lotTransferId",
    exact: true,
    name: "Home",
    component: Selectyourpayment,
  },
  {
    path: "/SelectyourpaymentForTransferlotEMD/:lotid",
    exact: true,
    name: "Home",
    component: SelectyourpaymentForTransferlotEMD,
  },
  {
    path: "/bidderuploadeddetails",
    exact: true,
    name: "Home",
    component: BidderUploadedDetails,
  },
  // {
  //   path: "/circlelist",
  //   exact: true,
  //   name: "Home",
  //   component: LoginPage,
  // },
  // {
  //   path: "/adduser",
  //   exact: true,
  //   name: "Home",
  //   component: AddUser,
  // },

  {
    path: "/adduserfortransfer/:lotId",
    exact: true,
    name: "Home",
    component: AddUserForTransfer,
  },
  // {
  //   path: "/addcircle",
  //   exact: true,
  //   name: "Home",
  //   component: AddCircleList,
  // },
  // {
  //   path: "/editcircle/:id",
  //   exact: true,
  //   name: "Home",
  //   component: EditCircle,
  // },
  // {
  //   path: "/districtlilst",
  //   exact: true,
  //   name: "Home",
  //   component: DistrictList,
  // },
  // {
  //   path: "/editdistrict/:id",
  //   exact: true,
  //   name: "Home",
  //   component: EditDistrict,
  // },
  // {
  //   path: "/adddistrict",
  //   exact: true,
  //   name: "Home",
  //   component: AddDistrict,
  // },
  // {
  //   path: "/edituser/:id",
  //   exact: true,
  //   name: "Home",
  //   component: EditUser,
  // },
  // // {
  // //   path: "/tenderlist",
  // //   exact: true,
  // //   name: "Home",
  // //   component: TenderList,
  // // },
  // // {
  // //   path: "/addtender",
  // //   exact: true,
  // //   name: "Home",
  // //   component: AddTender,
  // // },
  // // {
  // //   path: "/edittender/:id",
  // //   exact: true,
  // //   name: "Home",
  // //   component: EditTender,
  // // },
  // {
  //   path: "/senctionLetter/:id",
  //   exact: true,
  //   name: "Home",
  //   component: SenctionLetter,
  // },
  {
    path: "/profile",
    exact: true,
    name: "Home",
    component: BidderProfile,
  },
  {
    accessKey: "lot_invoice_list",
    path: "/invoice",
    exact: true,
    name: "Home",
    component: LotInvoiceList,
  },
  {
    path: "*",
    exact: false,
    name: "Home",
    component: Page404,
  },
];

export default cgmfRoutes;
